// Ciro hesaplama kuralları — (firma, iş türü, ciro kanalı) anahtarı üzerinden
// 1 kural. Ucretlendirme yontemleri pricing_method_ids array'inde tutulur
// (kural bir veya birden fazla pricing_method'a uygulanir).

export const GET_REVENUE_CALCULATION_RULES_QUERY = `
  query GetRevenueCalculationRules(
    $where: revenue_calculation_rules_bool_exp = {}
    $limit: Int
    $offset: Int
  ) {
    revenue_calculation_rules_aggregate(where: $where) {
      aggregate { count }
    }
    revenue_calculation_rules(
      where: $where
      order_by: [{ updated_at: desc }, { id: desc }]
      limit: $limit
      offset: $offset
    ) {
      id
      company_id
      job_type_id
      revenue_channel
      pricing_method_ids
      recurrence_type
      defined_months
      valid_job_statuses
      fee_source
      status
      description
      created_at
      updated_at
      company { id name }
      job_type { id name status_group is_project_based }
    }
  }
`;

export const GET_REVENUE_CALCULATION_RULE_BY_ID_QUERY = `
  query GetRevenueCalculationRuleById($id: Int!) {
    revenue_calculation_rules_by_pk(id: $id) {
      id
      company_id
      job_type_id
      revenue_channel
      pricing_method_ids
      recurrence_type
      defined_months
      valid_job_statuses
      fee_source
      status
      description
      created_at
      updated_at
      company { id name }
      job_type { id name status_group is_project_based }
    }
  }
`;

// Cirolarım lookup'ı — Yazım/Onay için (iş seçimi var, jobTypeId zorunlu).
// _or ile hem spesifik iş türüne hem genel (NULL) kurala da bakılır.
export const GET_REVENUE_CALCULATION_RULE_MATCH_QUERY = `
  query GetRevenueCalculationRuleMatch(
    $companyId: Int!
    $jobTypeId: Int!
    $revenueChannel: String!
    $pricingMethodId: Int!
  ) {
    revenue_calculation_rules(
      where: {
        company_id: { _eq: $companyId }
        _or: [
          { job_type_id: { _eq: $jobTypeId } }
          { job_type_id: { _is_null: true } }
        ]
        revenue_channel: { _eq: $revenueChannel }
        pricing_method_ids: { _contains: [$pricingMethodId] }
        status: { _eq: true }
      }
      order_by: { job_type_id: desc_nulls_last }
      limit: 1
    ) {
      id
      company_id
      job_type_id
      revenue_channel
      pricing_method_ids
      recurrence_type
      defined_months
      valid_job_statuses
      fee_source
      status
      description
      job_type { id name status_group }
    }
  }
`;

// Satış cirosu lookup'ı — iş seçilmediği için job_type_id NULL olan genel
// satış kuralını arar. Yazım/Onay'ın kullandığı MATCH_QUERY'den ayrı tutmak
// GraphQL'in null Int parametresine itiraz etmesini önler.
export const GET_REVENUE_CALCULATION_RULE_MATCH_FOR_SALES_QUERY = `
  query GetRevenueCalculationRuleMatchForSales(
    $companyId: Int!
    $revenueChannel: String!
    $pricingMethodId: Int!
  ) {
    revenue_calculation_rules(
      where: {
        company_id: { _eq: $companyId }
        job_type_id: { _is_null: true }
        revenue_channel: { _eq: $revenueChannel }
        pricing_method_ids: { _contains: [$pricingMethodId] }
        status: { _eq: true }
      }
      limit: 1
    ) {
      id
      company_id
      job_type_id
      revenue_channel
      pricing_method_ids
      recurrence_type
      defined_months
      valid_job_statuses
      fee_source
      status
      description
      job_type { id name status_group }
    }
  }
`;
